<template>
    <div class="my-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(item, index) in routeData" 
            :key="'crumb_'+index" :to="item.path">{{item.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            routeData: []
        }
    },
    mounted() {
        this.getBreadCrumb();
    },
    watch: {
        $route() {
            this.getBreadCrumb();
        }
    },
    methods: {
        // 获取路由
        getBreadCrumb() {
            let matched = this.$route.matched;
            console.log('matched', matched);
            this.routeData = matched;
        }
    }
}
</script>

<style lang="scss">
.my-breadcrumb {
    padding: 10px;
    color: #999;
    
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
        color: #999999;
        font-size: 12px;
    }
    .el-icon-arrow-right {
        font-size: 12px;
    }
    .el-breadcrumb__inner:hover{
        color: #db5634;
    }
}
</style>
